import { SearchResponse } from '@algolia/client-search';
import { DeviceType, QuerySuggestions, AlgoliaIndiceName } from '@packages/common';

import { SearchBase } from './searchBase';

export type QuerySuggestionSearchParams = {
  query: string;
  deviceType?: DeviceType;
};

export const querySuggestionSearch =
  (searchBase: SearchBase) =>
  ({
    query,
    deviceType = DeviceType.desktop,
  }: QuerySuggestionSearchParams): Promise<SearchResponse<QuerySuggestions> | null> => {
    if (query !== '' && query !== null && query !== undefined) {
      const hitsPerPage = deviceType === DeviceType.desktop ? 10 : 5;
      return searchBase<QuerySuggestions>(AlgoliaIndiceName.QUERY_SUGGESTIONS, {
        hitsPerPage,
        query,
      });
    }
    return new Promise((resolve) => resolve({ hits: [] } as any));
  };
